<template>
  <Table :loading="loading" border ref="table" ex :columns="columns" :data="data" @on-selection-change="selection">
    <template #tools="{ row }">
      <Button size="small" type="error" style="margin-left: 10px;" @click="removeFunction(row)">删除</Button>
    </template>
    <template #img="{ row }">
      <img style="width: 100px;" :src="row.goodsImg"/>
    </template>
  </Table>
  <Space v-margin="10" style="width: 100%; 
  display: flex; align-items: center; justify-content: center;">
    <Page v-model="page.current" :total="page.total" :page-size="page.size" show-total show-elevator show-sizer
      :page-size-opts="[10, 20, 50, 100]" @on-change="changePage" @on-page-size-change="changePageSize" />
  </Space>
</template>
<script>
import { infoPage, remove } from "@/api/pick/index";
import store from '@/store';

export default {
  data() {
    return {
      selectionRows: [],
      uploatModal: false,
      headers: {
        'Authorization': 'Bearer ' + store.getters.getToken
      },
      id: null,
      modal: false,
      columns: [
        {
          title: '奖品图片',
          slot: 'img',
          align: 'center'
        },
        {
          title: '奖品名称',
          key: 'goodsName',
          align: 'center'
        },
        {
          title: '获奖时间',
          key: 'createTime',
          align: 'center'
        },
        {
          title: '用户识别号',
          key: 'openid',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'tools',
          width: 150,
        }
      ],
      data: [],
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      loading: false
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    removeFunction(row) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '确认要删除该获奖信息吗（如需作废取货码请前往盲盒机管理后台）？',
        onOk: () => {
          remove([row]).then(res => {
            if (res.code == 0) {
              this.$Message.success("获奖信息删除成功！");
              this.getData()
            }
          })
        }
      });
    },
    getData() {
      this.loading = true
      infoPage({
        size: this.page.size,
        current: this.page.current
      }).then(res => {
        this.page.total = res.data.total
        this.data = res.data.records
        this.loading = false
      })
    },
    changePage() {
      this.getData()
    },
    changePageSize(res) {
      this.page.size = res
      this.getData()
    }
  }
}
</script>
<style></style>
@/api/subject/index